import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import PrivateRouter from "./PrivateRouter";
// import "./responsive.css";
import CartScreen from "./screens/CartScreen";
import HomeScreen from "./screens/HomeScreen";
import Login from "./screens/Login";
import NotFound from "./screens/NotFound";
import OrderScreen from "./screens/OrderScreen";
import PaymentScreen from "./screens/PaymentScreen";
import PlaceOrderScreen from "./screens/PlaceOrderScreen";
import ProfileScreen from "./screens/ProfileScreen";
import Register from "./screens/Register";
import ShippingScreen from "./screens/ShippingScreen";
import SingleProduct from "./screens/SingleProduct";
import SingleProductOld from "./screens/SingleProductOld";
import DepositScreen from "./screens/DepositScreen";
import Category from "./screens/Category";
import { getUserDetails } from "./redux/Actions/UserActions";
import { useDispatch, useSelector } from "react-redux";

import Setpass from "./screens/Setpass";
// import Reset from "./screens/ResetPass";
// import VerificationReset from "./screens/VerificationReset";
// import Changepass from "./screens/Changepass";
// import VerificationChangepass from "./screens/VerificationChangepass";
import VerificationMail from "./screens/VerificationMail";
import { getUser } from "./service";
import useSaveRef from "./lib/useSaveRef";
import OrdersNone from "./screens/OrdersNone";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { Topbar } from "./components/Topbar";
import MenusHeader from "./components/MenusHeader";
import Checkout from "./screens/Checkout";
import { Subscription } from "./components/Subscription";
import { CartModal } from "./components/CartModal";
import ContactPage from "./screens/ContactPage";
import Blog from "./screens/Blog";
import BlogDetail from "./screens/BlogDetail";
import ScrollToTop from "./components/ScrollToTop";


// import { getUserDetails } from "../redux/Actions/UserActions";

const App = () => {
  const isCheckoutPage = useSelector((state) => state.appReducer.isCheckoutPage);
  console.log("isCheckoutPageisCheckoutPage ",isCheckoutPage);
  
  const dispatch = useDispatch();
  useSaveRef();
  useEffect(() => {
    dispatch(getUserDetails("profile"));
  }, [dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      getInfoUserActive();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const getInfoUserActive = async () => {
    let data = await getUser();
    // console.log(data);
    if (data.code == 200) {
      localStorage.setItem("userInfoActive", JSON.stringify(data.data));
    }
  };

  return (
    <div className="overflow-hidden">

      <Router>
        {!isCheckoutPage && <> <Topbar />
          <Header />
          <MenusHeader /></>}
          <CartModal/>
        <Switch>

          <Route path="/" component={HomeScreen} exact />
          <Route path="/products/:id" component={SingleProduct} />
          <Route path="/productsOld/:id" component={SingleProductOld} />
          <Route path="/login" component={Login} />
          <Route path="/register" component={Register} />
          <Route path="/profile" component={ProfileScreen} />
          <Route path="/cart/:id?" component={CartScreen} />
          <Route path="/orders-none" component={OrdersNone} />
          <Route path="/category/:id?" component={Category} />
          <Route path="/contact" component={ContactPage} />
          <Route path="/blogs" component={Blog} />
          <Route path="/blog/:id?" component={BlogDetail} />
          {/* <PrivateRouter path="/shipping" component={ShippingScreen} />
        <PrivateRouter path="/payment" component={PaymentScreen} />
        <PrivateRouter path="/placeorder" component={PlaceOrderScreen} />
        <PrivateRouter path="/order/:id" component={OrderScreen} />
        <PrivateRouter path="/deposit" component={DepositScreen} /> */}


          <Route path="/checkout" component={Checkout} />
          <Route path="/shipping" component={ShippingScreen} />
          <Route path="/payment" component={PaymentScreen} />
          <Route path="/placeorder" component={PlaceOrderScreen} />
          <Route path="/order/:id" component={OrderScreen} />
          <PrivateRouter path="/deposit" component={DepositScreen} />

          {/* <Route path="/verification-changepass" component={VerificationChangepass} /> */}
          <Route path="/verification-mail/:email/:ref" component={VerificationMail} />
          <Route path="/setpass/:email/:token/:ref" component={Setpass} />
          {/* <Route path="/reset" component={Reset} /> */}
          {/* <Route path="/changepass" component={Changepass} /> */}
          {/* <Route path="/verification-reset/:email" component={VerificationReset} /> */}

          <Route path="*" component={NotFound} />

        </Switch>
        <ScrollToTop/>
        {!isCheckoutPage && <><div className="mt-8">   <Subscription /></div>
          <div className="mt-8">   
            {/* <Footer /> */}
            </div> </>
          }
      </Router>

    </div>
  );
};

export default App;
